import type { SerializedStyles, Theme } from '@emotion/react';
import { css } from '@emotion/react';

import type { Colors } from './message-box';

export const box = (theme: Theme) => css`
  display: grid;
  position: relative;
  width: 100%;
  grid-template-columns: max-content 1fr;
  grid-template-rows: 1fr;
  column-gap: ${theme.spacing[8]};
  align-items: center;
  padding: ${theme.spacing[8]} ${theme.spacing[16]};
`;

export const background: Record<Colors, (theme: Theme) => SerializedStyles> = {
  primary: (theme) => css`
    background-color: ${theme.palette.secondary.lowContrast};
  `,
  success: (theme) => css`
    background-color: ${theme.palette.success.lowContrast};
  `,
  warning: (theme) => css`
    background-color: ${theme.palette.warning.lowContrast};
  `,
  gray: (theme) => css`
    background-color: ${theme.palette.tertiary.mediumContrast};
  `,
};
